module.exports = __webpack_public_path__ + "static/media/setDarkMode.9b9275ca.wav";